export default () => ({
    page: window.location.pathname,
    query: `${window.location.search}${window.location.hash}`,
    referrer: document.referrer,
});